import { useCallback } from 'react';
import axios, { useApiRequest } from './axios';
import { LoginResponse } from '../types/auth';

const GOOGLE_AUTHENTICATION_URL = '/auth/google/authentication/';

export const useGoogleAuthenticationMutation = () => {
  const { loading, error, executeRequest } = useApiRequest();

  const verifyMutation = useCallback(async (credential: string): Promise<{ data: LoginResponse | undefined, success: boolean }> => {
    const { data, success } = await executeRequest(() =>
      axios.post(GOOGLE_AUTHENTICATION_URL, { credential })
    );
    return { data, success };
  }, [executeRequest]);

  return { loading, error, verifyMutation };
};
